import { API_BASE,axiosApi } from "../config"
import { GeneralReturnInterface, GetSampleReturnInterface, SampleStatusType } from "../types"




export async function updateWellSample(body: { wellId: number, sampleId: string | number|null }): Promise<GeneralReturnInterface> {
    return (await axiosApi.post(`${API_BASE}/updateWellSample`,body)).data
}

export async function getSample(body: { sampleId: string | number }): Promise<GetSampleReturnInterface> {
    return (await axiosApi.post(`${API_BASE}/getSample`,body)).data
   
}

export async function updateSampleStatus(body: { sampleId: string | number, status: SampleStatusType }): Promise<GetSampleReturnInterface> {
    return (await axiosApi.post(`${API_BASE}/updateSampleStatus`,body)).data
   
}

export async function fixSampleNumbers(body: { orderId: number }): Promise<GeneralReturnInterface> {
    return (await axiosApi.post(`${API_BASE}/fixSampleNumbers`,body)).data
}

export async function fixAllSampleNumbers(): Promise<GeneralReturnInterface> {
    return (await axiosApi.post(`${API_BASE}/fixAllSampleNumbers`)).data
}

export async function updateSampleName(body: { sampleId: number, sampleName: string }): Promise<GeneralReturnInterface> {
    return (await axiosApi.post(`${API_BASE}/updateSampleName`, body)).data
}
